import { lodashDeepClone, merge } from 'utils'

import { useCloudComputingPower } from 'store/src/stores/use-cloud-computing-power'
import { default as ico, default as simpleLogo } from '../../assets/image/88/favicon.png'
import bannerRightEn from '../../assets/image/88/home/banner-right-en.png'
import bannerRightZh from '../../assets/image/88/home/banner-right-zh.png'
import downloadBgEn from '../../assets/image/88/home/support-platform/download-en.png'
import downloadBgZh from '../../assets/image/88/home/support-platform/download-zh.png'
import logo from '../../assets/image/88/logo-dark.png'
import { BaseConfig, type BaseConfigSource } from '../common-config'

/** 海报相关 --- start */
import cnPoster1 from '../../assets/image/88/poster/zh_CN/1.png'
import cnPoster2 from '../../assets/image/88/poster/zh_CN/2.png'
import cnPoster3 from '../../assets/image/88/poster/zh_CN/3.png'
import cnBanner from '../../assets/image/88/poster/zh_CN/banner.png'

import enPoster1 from '../../assets/image/88/poster/en/1.png'
import enPoster2 from '../../assets/image/88/poster/en/2.png'
import enPoster3 from '../../assets/image/88/poster/en/3.png'
import enBanner from '../../assets/image/88/poster/en/banner.png'
import { debitCard } from './common'
/** 海报相关 --- end */

/** 合规相关 */
import arkham from '../../assets/image/top-credit/legal-compliance/arkham-dark.png'
import blocksec from '../../assets/image/top-credit/legal-compliance/blocksec-dark.png'
import chainanalysis from '../../assets/image/top-credit/legal-compliance/chainalysis-dark.png'
import cloudFlare from '../../assets/image/top-credit/legal-compliance/cloud-flare-dark.png'
import elliptic from '../../assets/image/top-credit/legal-compliance/elliptic-dark.png'
import googleCloud from '../../assets/image/top-credit/legal-compliance/google-cloud-dark.png'
import jamf from '../../assets/image/top-credit/legal-compliance/jamf-dark.png'
import nansen from '../../assets/image/top-credit/legal-compliance/nansen-dark.png'
import slowmist from '../../assets/image/top-credit/legal-compliance/slowmist-dark.png'
import sumsub from '../../assets/image/top-credit/legal-compliance/sumsub-dark.png'

const primary = '#F7B239'
const lightPrimary = '#D5A35D'
const secondaryPrimary = '#E81B40'
const tertiaryPrimary = '#8B1A1A'

const textColor = '#151519'

const primaryGradient = 'linear-gradient(270deg, #EECA7D 0%, #D5A35D 100%)'

/** 88配置 */
export const E88DarkConfig: PlatformConfig = merge<BaseConfigSource, PlatformConfig>(lodashDeepClone(BaseConfig), {
  themeType: 'dark',
  logo: logo,

  simpleLogo,
  footerLogo: logo,
  platformName: '88',
  loginShowDownload: true,
  colors: {
    hoverPrimary: '#fff',
    lightPrimary: lightPrimary,
    zero: '#424242',
    status: {
      error: '#E81B40',
      success: '#28BA97',
      ing: '#3C53FF',
    },
    // 根据最新的UI提供的色值库的颜色
    primary,
    primaryGradient,
    secondaryPrimary,
    tertiaryPrimary,
    error: '#FC495C',
    warning: '#FF8A00',
    success: '#00D391',
    link: '#4B5BE7',
    text: {
      base: '#FFFFFF',
      reverse: '#fff',
      primaryAlt: '#D3D4DB',
      secondary: '#A0A3A7',
      tertiary: '#6A6C75',
      quaternary: '#75777A',
      hover: '#FFFFFF',
    },
    bg: {
      base: '#000',
      reverse: '#ffffff',
      secondary: '#1E1E24',
      hover: '#EAECEF0C',
      tertiary: '#292930',
      icon: {
        primary: '#EAECEF',
        secondary: '#A0A3A7',
        trigger: '#16161A',
        quaternary: '#A0A3A7',
      },
      button: {
        base: primary,
        primary: primary,
        primaryTextColor: textColor,
        disabledTextColor: '#fff',
        aux: '#414142',
        disabled: '#A0A0A0',
      },
      tag: {
        base: '#2B2C35',
      },
      form: {
        base: '#1F2023',
        input: '#1F2023',
        modal: '#2C2C2C',
        card: '#23242A',
      },
      mainPage: {
        base: '#16161A',
        card: '#23242A',
        actionBar: '#2B2C35',
      },
      modal: {
        base: '#252525',
        card: '#23242A',
        shadow: 'rgba(0, 0, 0, 0.10)',
      },
    },
    tip: '#2C2C2C',
    cardBorder: '#373739',
    divider: '#26272D',
    borderSelected: '#A0A3A7',
    sliderMenu: '#2C2C2C',
  },
  ico,
  header: {
    boxShadow: 'none',
    background: '#000',
    color: '#fff',
    // boxShadow: '0 1px 10px rgba(0, 0, 0, 0.11)',
    aColor: '#fff',
    regBtnBgColor: '#FFFF38', // 注册按钮背景
    regTextColor: '#10151F', // 注册按钮文字颜色
    downloadTextColor: '#fff',
    activeColor: '#fff',
  } as PlatformConfig['header'],
  home: {
    banner: {
      bannerRight: {
        zh: bannerRightZh,
        en: bannerRightEn,
      },
    },
    supportPlatform: {
      appStore: false,
      downloadBg: {
        zh: downloadBgZh,
        en: downloadBgEn,
      },
    },
  },

  loadExternalConfig() {
    return useCloudComputingPower().loadExternalConfig()
  },
  debitCard: debitCard,
  cloud: {
    colors: {
      bg: {
        card: {
          primary: '#2B2C35',
          fontColor: '#fff',
        },
      },
    },
  },
  posterConf: {
    zh_CN: {
      poster1: cnPoster1,
      poster2: cnPoster2,
      poster3: cnPoster3,
      banner: cnBanner,
    },
    en: {
      poster1: enPoster1,
      poster2: enPoster2,
      poster3: enPoster3,
      banner: enBanner,
    },
  },
  compliance: {
    cooperativeInstitutions: {
      list: [
        { logo: chainanalysis, width: 170 },
        { logo: slowmist, width: 154 },
        { logo: nansen, width: 140 },
        { logo: elliptic, width: 130 },
        { logo: jamf, width: 94 },
        { logo: cloudFlare, width: 178 },
        { logo: arkham, width: 140 },
        { logo: sumsub, width: 150 },
        { logo: googleCloud, width: 165 },
        { logo: blocksec, width: 160 },
      ],
    },
  },
} as BaseConfigSource as PlatformConfig)
